const FIELD_LABELS = {
  interview_form_agreed: '是否同意面试形式',
  available_times: '可约时间',
  confirmed_time: '确认时间',
};

export function fieldLabel(key) {
  return FIELD_LABELS[key] || key;
}

export function formatDisplayValue(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'boolean') return value ? '是' : '否';
  if (Array.isArray(value)) {
    return value.map((item) => formatDisplayValue(item)).filter((item) => item !== '').join('、');
  }
  if (typeof value === 'object') {
    try {
      return Object.keys(value).map((key) => `${fieldLabel(key)}：${formatDisplayValue(value[key])}`).join('\n');
    } catch (e) {
      return '';
    }
  }
  return String(value);
}
